// eslint-disable-next-line

import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import EmailIcon from "@mui/icons-material/Email";
import GradeIcon from "@mui/icons-material/Grade";
import { Card, CardContent, Divider, Typography } from "@mui/material";
import { Button, Input, Modal, notification } from "antd";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import BASE_URL from "../constants";
import AuthContext from "../context/AuthContext";
import { renderNullable } from "../utils/renderNullable";
import useAxios from "../utils/useAxios";

const MyProfile = () => {
	const { authTokens } = useContext(AuthContext);
	const [userObj, setUserObj] = useState({});
	const [open, setOpen] = useState(false);
	const [confirmLoading, setConfirmLoading] = useState(false);
	const [newPassword, setNewPassword] = useState("");

	const showModal = () => {
		setOpen(true);
	};
	const handleOk = () => {
		setConfirmLoading(true);
		changePassword();
	};

	const handleCancel = () => {
		setOpen(false);
		setNewPassword("");
	};

	useEffect(() => {
		getUser();
		// getUser depends on `api`(useAxios())で、api は毎レンダー新規生成されるため
		// 依存配列に含めると無限に再実行される。マウント時1回のみ実行する意図的な設計。
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const api = useAxios();

	const getUser = async () => {
		try {
			// GET user details
			const response = await api.get(`user/get_user/`, {
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + String(authTokens.access),
				},
			});

			if (response.status === 200) {
				const data = response.data;
				setUserObj(data);
			} else {
			}
		} catch (e) {
			console.error(e);
			notification.error({
				message: "Failed to Load Profile",
				description:
					"Could not load your profile. Please reload the page or try again later.",
			});
		}
	};

	const changePassword = async () => {
		setConfirmLoading(true);
		try {
			await axios.patch(
				`${BASE_URL}/user/change_password/${userObj.id}/`,
				{
					password: newPassword,
				},
				{
					headers: {
						"Content-Type": "application/json",
						Authorization: "Bearer " + String(authTokens.access),
					},
				},
			);
			setConfirmLoading(false);
			setOpen(false);
			setNewPassword("");
			notification.success({
				message: "Successfully Changed Password",
				description: `You've successfully changed your password`,
			});
		} catch (error) {
			setConfirmLoading(false);
			setOpen(false);
			notification.error({
				message: "Password Change Error",
				description: `Failed to change password`,
			});
		}
	};

	return (
		<div className="container">
			<Card
				sx={{
					minWidth: "100%",
					maxWidth: 500,
					m: 2,
					bgcolor: "background.paper",
				}}
			>
				<CardContent>
					<Typography
						variant="h5"
						component="div"
						sx={{ color: "primary.main" }}
					>
						Profile Overview
					</Typography>
					<Divider sx={{ mb: 2 }} />
					<Typography sx={{ mb: 2 }} color="text.secondary">
						<AlternateEmailIcon /> {renderNullable(userObj.username)}
					</Typography>
					<Typography sx={{ mb: 2 }} color="text.secondary">
						First Name: {renderNullable(userObj.first_name)}
					</Typography>
					<Typography sx={{ mb: 2 }} color="text.secondary">
						Last Name: {renderNullable(userObj.last_name)}
					</Typography>
					<Typography sx={{ mb: 2 }} color="text.secondary">
						<EmailIcon sx={{ mr: 1 }} /> {renderNullable(userObj.email)}
					</Typography>
					<Typography sx={{ mb: 2 }} color="text.secondary">
						HR Code: {renderNullable(userObj.hrCode)}
					</Typography>
					<Typography sx={{ mb: 2 }} color="text.secondary">
						<GradeIcon /> Grade: {renderNullable(userObj.grade)}
					</Typography>
					<Typography sx={{ mb: 2 }} color="text.secondary">
						NAT Group: {renderNullable(userObj.natGroup)}
					</Typography>
					<Typography sx={{ mb: 2 }} color="text.secondary">
						Expert: {renderNullable(userObj.expert)}
					</Typography>
					<Typography sx={{ mb: 2 }} color="text.secondary">
						Organization Code: {renderNullable(userObj.organizationCode)}
					</Typography>
					<Typography sx={{ mb: 2 }} color="text.secondary">
						Position: {renderNullable(userObj.position)}
					</Typography>
				</CardContent>
				<div
					style={{ justifyContent: "center", display: "flex", margin: "2%" }}
				>
					<Button onClick={showModal} style={{ width: "40%" }} danger>
						Change Password
					</Button>
					<Modal
						title="Change Password"
						open={open}
						onOk={handleOk}
						confirmLoading={confirmLoading}
						onCancel={handleCancel}
						okButtonProps={{ disabled: newPassword.trim() === "" }}
					>
						<div
							style={{
								marginTop: "3%",
								textAlign: "center",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
							}}
						>
							<Input.Password
								placeholder="New Password"
								value={newPassword}
								onChange={(e) => setNewPassword(e.target.value)}
							/>
						</div>
					</Modal>
				</div>
			</Card>
		</div>
	);
};

export default MyProfile;
